<ngx-loading [show]="loading"></ngx-loading>

<div
  class="col-md-12 col-sm-12 col-xs-12"
  style="min-height: 400px; overflow-y: auto"
  *ngIf="!isAutoRedirectSet"
>
  <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 reviewbottom">
    <div class="col-md-12 col-col-sm-12 col-xs-12 thankyoureview">
      <span
        ><img
          [src]="logo_url"
          class="img-responsive"
          width="100"
          *ngIf="logo_url != undefined"
        /><span class="bus_name_review">{{ business_name }}</span></span
      >
    </div>
    <div class="col-md-12 col-col-sm-12 col-xs-12 thankyoureview">
      <h5>Hi {{ customer_name }},</h5>
      <ng-container>
        <p *ngIf="reviewsby.length != 1 && !fromNegativePage">
          Please take a moment to share your feedback on one of these review
          sites!
        </p>
        <p *ngIf="reviewsby.length == 1 && !fromNegativePage">
          Please take a moment to share your feedback on Zceppa
        </p>
        <p *ngIf="reviewsby.length != 1 && fromNegativePage">
          Thanks for providing your feedback. If you wish to, please choose one
          of the platforms below to leave a public Review.
        </p>
        <p *ngIf="reviewsby.length == 1 && fromNegativePage">
          Thanks for providing your feedback. If you wish to, please choose one
          of the platforms below to leave a public Review.
        </p>
      </ng-container>
    </div>

    <ng-container >
      <div
        class="col-md-12 col-col-sm-12 col-xs-12 reviewanyone"
        *ngIf="success_slug === true"
      >
        <perfect-scrollbar
          style="max-width: 100%; max-height: 100%; margin-bottom: 75px"
        >
          <ul>
            <ng-container *ngFor="let review of reviewsby; let i = index">
              <li
                [ngClass]="review.class"
                *ngIf="review.source === true && review.link != null"
                (click)="postReviewBy(review.link)"
              >
                <img [src]="review.image" class="img-responsive" />
                <span>{{ review.reviewby }}</span>
              </li>
            </ng-container>
          </ul>
        </perfect-scrollbar>
      </div>

      <div class="text-center">
        <span class="mr-2">Receive notifications via WhatsApp</span>
        <label class="switch mb-0">
          <input
            type="checkbox"
            id="togBtn"
            [(ngModel)]="optionForWhatsApp"
            (ngModelChange)="optedinWhatsApp(optionForWhatsApp)"
            [ngModelOptions]="{ standalone: true }"
          />
          <div class="slider round">
            <!--ADDED HTML -->
            <span class="on">Enabled</span><span class="off">Disabled</span>
            <!--END-->
          </div>
        </label>
      </div>
    </ng-container>
  </div>
</div>

<footer *ngIf="showPoweredBy">
  <div class="col-md-12 col-col-sm-12 col-xs-12">
    <div
      class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 thankyoureviewfooter"
    >
      <p>Powered by</p>
      <a href="https://www.zceppa.com/?utm_source=zceppa&utm_medium=consumer_link&utm_campaign=review_invite" target="_blank">
        <img src="assets/images/zceppadark.svg" class="img-responsive" />
      </a>
    </div>
  </div>
</footer>

<ng-template #errorModal let-modal>
  <div class="modal-body locat_pop text-center">
    <h4>Error</h4>
    <p>{{ error_message }}</p>
  </div>
</ng-template>

<ng-template #zceppaReviewModal>
  <div class="col-lg-12 col-md-12 col-sm-12 feedbackimprove">
    <h4>Please share your feedback to help us improve!</h4>
    <div class="col-md-12 col-sm-12">
      <div class="form-group">
        <textarea placeholder="Feedback" [(ngModel)]="feedback"></textarea>
      </div>
      <div class="form-group text-center">
        <ngb-rating
          class="star-rating"
          [starTemplate]="ratingStar"
          [(rate)]="selected_rating"
          (hover)="ratings = $event"
          (leave)="hovered = 0"
          [readonly]="readonly"
        ></ngb-rating>
      </div>
    </div>
    <div class="col-md-12 col-sm-12 text-center">
      <button
        [disabled]="isSubmitClicked"
        class="action-button btn"
        (click)="thankyouModal()"
      >
        Ok
      </button>
    </div>
  </div>
</ng-template>

<ng-template #thankyoumodal>
  <div class="col-lg-12 col-md-12 col-sm-12 feedbackimprove">
    <h3>
      Thank you for your feedback. We will look into it and get back to you
      shortly
    </h3>
    <div class="col-md-12 col-sm-12 text-center">
      <button class="action-button btn" (click)="closeModal()">Ok</button>
    </div>
  </div>
</ng-template>

<ng-template #ratingStar let-fill="fill">
  <span class="star" [class.full-star]="fill === 100">
    <span class="half-star" [style.width.%]="fill">&#9733;</span>&#9733;
  </span>
</ng-template>
